import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FormsyDate from "../../forms/formComponents/FormsyDate";
import formatDate from "../../../../utils/formatDate";
import ProjectReportCard from "./ProjectReportCard";

class ProjectReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      companies: [{ id: -1, name: "All Companies" }],
      responsibleParties: [
        { id: "-2", name: "No Filter" },
        { id: "-1", name: "Assigned to Anyone" },
        { id: "0", name: "Unassigned" },
      ],
      company: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.renderSelection = this.renderSelection.bind(this);
    this.renderReportCard = this.renderReportCard.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    let url = `/api/teamwork/projectFormSelections`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        let companies = this.state.companies.concat(json.companies);
        let responsibleParties = this.state.responsibleParties.concat(
          json.responsibleParties,
        );
        this.setState({
          companies: companies,
          responsibleParties: responsibleParties,
        });
        this.props.stopLoading();
      });
  }

  submitForm(data) {
    // console.log(JSON.stringify(data));
    this.props.getWorkorders();

    let url = "/api/teamwork/projectReports";
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify({ data: data }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.length === 0) {
          alert("No projects found");
        }
        this.props.receiveWorkorders(json);
      });
  }

  notifyFormError(data) {
    alert("Missing Data: check that all fields are filled");
    console.error("Form error:", data);
  }

  renderSelection(selection, i) {
    return (
      <MenuItem
        key={selection.id}
        primaryText={selection.name}
        value={selection.id}
      />
    );
  }

  renderReportCard(project, i) {
    let style = { marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" };
    if (i % 2 !== 0) {
      style.backgroundColor = "#F5F5F5";
    }
    return (
      <Paper key={i} className="container" zDepth={2} style={style}>
        <ProjectReportCard
          project={project}
          token={this.props.token}
          color={this.props.appbar.color}
        />
      </Paper>
    );
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else if (this.props.workOrders.length === 0) {
      let { centerStyle } = this.state.styles;
      let priorityLevels = [
        { id: "any", name: "Any" },
        { id: "low", name: "Low" },
        { id: "medium", name: "Medium" },
        { id: "high", name: "High" },
      ];

      let dateFilter = [
        { id: "all", name: "All" },
        { id: "anytime", name: "Anytime" },
        { id: "overdue", name: "Overdue" },
        { id: "today", name: "Today" },
        { id: "tomorrow", name: "Tomorrow" },
        { id: "thisweek", name: "This week" },
        { id: "within7", name: "Within 7" },
        { id: "within14", name: "Within 14" },
        { id: "within30", name: "Within 30" },
        { id: "within365", name: "Within 365" },
        { id: "nodate", name: "No Date" },
        { id: "nostartdate", name: "No Start Date" },
        { id: "completed", name: "Completed" },
      ];

      return (
        <div>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Formsy.Form
              ref="form"
              onValidSubmit={this.submitForm}
              onInvalidSubmit={this.notifyFormError}
            >
              <div style={centerStyle}>
                <h1 style={{ marginBottom: "1em" }}>Project Report Cards</h1>
              </div>
              <Divider />
              <Subheader>Date Range</Subheader>
              <div style={centerStyle}>
                <FormsyDate
                  name="startDate"
                  required
                  fullWidth={true}
                  firstDayOfWeek={0}
                  formatDate={(date) => formatDate(date)}
                  floatingLabelText="Start Date"
                />
                <FormsyDate
                  name="endDate"
                  required
                  fullWidth={true}
                  firstDayOfWeek={0}
                  formatDate={(date) => formatDate(date)}
                  floatingLabelText="End Date"
                />
              </div>
              <Divider />
              <Subheader>Company</Subheader>
              <div style={centerStyle}>
                <FormsySelect
                  required
                  fullWidth
                  name="company"
                  floatingLabelText="Choose Company"
                >
                  {this.state.companies.map(this.renderSelection)}
                </FormsySelect>
              </div>
              <Divider />
              <Subheader>Responsible Party</Subheader>
              <div style={centerStyle}>
                <FormsySelect
                  required
                  fullWidth
                  name="responsibleParty"
                  floatingLabelText="Choose Responsible Party"
                >
                  {this.state.responsibleParties.map(this.renderSelection)}
                </FormsySelect>
              </div>
              <Divider />
              <Subheader>Priority</Subheader>
              <div style={centerStyle}>
                <FormsySelect
                  required
                  fullWidth
                  name="priority"
                  floatingLabelText="Choose Priority Level"
                >
                  {priorityLevels.map(this.renderSelection)}
                </FormsySelect>
              </div>
              <Divider />
              <Subheader>Date Filter</Subheader>
              <div style={centerStyle}>
                <FormsySelect
                  required
                  fullWidth
                  name="dateFilter"
                  floatingLabelText="Choose Date Filter"
                >
                  {dateFilter.map(this.renderSelection)}
                </FormsySelect>
              </div>
              <Divider />
              {/*<Subheader>Report Options</Subheader>
						<div style={centerStyle}>
							<FormsyCheckbox
								name='starred'
								label='Only Starred Projects'
							/>
						</div>*/}
              <Divider />
              <div style={centerStyle}>
                <div className="col-sm-6">
                  <FlatButton
                    backgroundColor="#A5D6A7"
                    hoverColor="#81C784"
                    style={{ marginTop: "2em", marginBottom: "1em" }}
                    label="Generate"
                    type="submit"
                  />
                </div>
                <div className="col-sm-6">
                  <FlatButton
                    backgroundColor="#E0E0E0"
                    hoverColor="#BDBDBD"
                    style={{ marginTop: "2em", marginBottom: "1em" }}
                    label="Cancel"
                  />
                </div>
              </div>
            </Formsy.Form>
            <br />
          </Paper>
        </div>
      );
    } else {
      return <div>{this.props.workOrders.map(this.renderReportCard)}</div>;
    }
  }
}

export default ProjectReports;



// WEBPACK FOOTER //
// ./app/components/teamwork/projects/ProjectReports.js